export class Contador {
    time_buffer: number;
    ComecoContagem: Date;
    ativo: boolean;
    constructor(time_buffer: number = 0, ComecoContagem: Date = new Date(), ativo: boolean = false){
        this.time_buffer = time_buffer;
        this.ComecoContagem = ComecoContagem;
        this.ativo = ativo;
    }
    iniciaContagem(agora: Date): void {
        this.ComecoContagem = agora;
        this.ativo = true;
    }
    protected segundosPassado(agora: Date): number {
        if (!this.ativo) {
            return this.time_buffer;
        }
        else {
            return this.time_buffer + Math.floor((agora.getTime() - this.ComecoContagem.getTime()) / 1000);
        }
    }
    protected formatarTempo(segundos: number): string {
        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const segundosRestantes = segundos % 60;
        return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundosRestantes).padStart(2, '0')}`;
    }
    tempoPassado(agora: Date): string {
        return this.formatarTempo(this.segundosPassado(agora));
    }
    pausaContagem(agora: Date): void {
        this.time_buffer = this.segundosPassado(agora);
        this.ativo = false;
    }
}

